import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Box, Grid, Typography } from "@mui/material";
import { useComment } from "@platformx/authoring-apis";
import { CommentListPanel, CommentWrapper } from "@platformx/comment-review";
import { CloudIcon } from "@platformx/shared/static-assets";
import { ManualCropUsingCdn } from "@platformx/x-image-render";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../CreateArticle.styles";
import ArticleImageRender from "../ArticleImageRender/ArticleImageRender";
import Description from "../Description/Description";
import { ImageOnHoverCard } from "../ImageOnHoverCard/ImageOnHoverCard";
import ShortDescription from "../ShortDescription";
import Title from "../Title";

export const ArticleDetails = ({
  returnBack,
  onHover,
  setOnHover,
  content,
  setContent,
  state,
  setState,
  setSelectedImage,
  selectedImage,
  onUploadClick,
  operationType: _operationType,
  resetSelectedImage,
  updateImageField,
  setIsClickedPublish,
  setCheckDesc,
  workflow,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { scrollToRef } = useComment();
  const [manualCropShow, setManualCropShow] = useState(false);

  const doneCropCompleted = (cropHints: any[] = []) => {
    if (cropHints.length > 0) {
      updateImageField({
        published_images: cropHints,
        original_image: state?.ObjectFields?.original_image,
      });
    }
    setManualCropShow(false);
  };

  const handleClearImage = () => {
    setContent({ Url: "", Title: "", Description: "", bitStreamId: "" });
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        settings: {
          ...state.CommonFields.settings,
          socialog_image: "",
        },
        structure_data: "",
      },
      ObjectFields: {
        ...state.ObjectFields,
        banner: "",
        published_images: [],
        original_image: {},
      },
    });
    resetSelectedImage();
  };

  useEffect(() => {
    const originalImage = state?.ObjectFields?.original_image;
    if (originalImage && Object.keys(originalImage).length !== 0) {
      setSelectedImage({ ...originalImage });
    }
  }, [state?.ObjectFields?.original_image]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}>
        <Box className='createarticlebottomhead'>
          <Box className='d-flex align-items-center justify-content-space-between'>
            <Box className='backspace' onClick={returnBack} data-testid='returnback'>
              <KeyboardBackspaceIcon />
            </Box>
          </Box>
        </Box>
        <Grid
          container
          sx={{
            padding: {
              lg: "0 20px 30px 286px",
              xs: "0 20px 30px 20px",
              md: "0 20px 30px 200px",
            },
            maxHeight: "calc(100vh - 68px)",
            flexWrap: "nowrap",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          }}>
          <Grid container>
            <Grid item xs={12} md={9} lg={5}>
              <CommentWrapper
                elementId='1'
                scrollRef={scrollToRef}
                // comments={comments}
                workflow={workflow}>
                <Box className={classes.contentStyle}>
                  {content?.Url ? (
                    <Box className={classes.imgUploadBox}>
                      <Box
                        onMouseEnter={() => setOnHover(true)}
                        className={classes.hoverCard}
                        data-testid='imgupload'
                      />
                      <ArticleImageRender
                        content={selectedImage}
                        imgOrder={{
                          1440: "hero",
                          1280: "landscape",
                          1024: "card2",
                          768: "square",
                          600: "card1",
                          320: "portrait",
                        }}
                      />
                    </Box>
                  ) : (
                    <Box
                      onClick={() => {
                        setIsClickedPublish(false);
                        onUploadClick("Images", "choose");
                      }}
                      data-testid='article-image-upload'
                      className={classes.imgUploadBox}>
                      <Box className={classes.heroBannerCloudIconBox}>
                        <img src={CloudIcon} alt='img' />
                      </Box>
                    </Box>
                  )}
                  <Box className={classes.urlEllipisis}>
                    <Typography variant='h7medium'>
                      {content?.Url ? `${t("banner")}: ${content?.Title}` : t("choose_banner")}
                    </Typography>
                  </Box>
                  {state?.ObjectFields?.published_images.length > 0 && (
                    <Box
                      onClick={handleClearImage}
                      data-testid='article-clear-img'
                      className={classes.closeIconStyle}>
                      <CloseOutlinedIcon sx={{ height: "15px", width: "15px" }} />
                    </Box>
                  )}
                </Box>
              </CommentWrapper>
            </Grid>
          </Grid>
          <Grid item xs={12} md={10} lg={10}>
            <Box
              sx={{
                backgroundColor: "#ffffff",
                paddingBottom: { xs: "20px", md: "50px" },
              }}>
              <CommentWrapper elementId='2' scrollRef={scrollToRef}>
                <Title state={state} setState={setState} />
              </CommentWrapper>
              <CommentWrapper elementId='4' scrollRef={scrollToRef}>
                <ShortDescription state={state} setState={setState} />
              </CommentWrapper>
              <CommentWrapper elementId='3' scrollRef={scrollToRef}>
                <Description
                  title={state?.CommonFields?.title}
                  state={state}
                  setState={setState}
                  setCheckDesc={setCheckDesc}
                />
              </CommentWrapper>
            </Box>
          </Grid>
          {onHover && (
            <ImageOnHoverCard
              onUploadClick={onUploadClick}
              setIsClickedPublish={setIsClickedPublish}
              setOnHover={setOnHover}
              originalImage={state?.ObjectFields?.original_image}
              onCropClick={() => {
                setOnHover(false);
                setManualCropShow(true);
              }}
            />
          )}
          {manualCropShow && (
            <ManualCropUsingCdn
              open={manualCropShow}
              backTo={() => setManualCropShow(false)}
              isCrop={true}
              doneCropCompleted={doneCropCompleted}
              originalImage={state?.ObjectFields?.original_image}
              published_images={state?.ObjectFields?.published_images || []}
            />
          )}
        </Grid>
      </Box>
      <CommentListPanel></CommentListPanel>
    </>
  );
};
